// Load template gitignore từ src/templates/gitignore/<stack>.txt và compose
// nội dung tổng hợp cho 1+ stack. Generic luôn được prepend.
import { readFileSync } from "node:fs";
import { dirname, join } from "node:path";
import { fileURLToPath } from "node:url";
import type { TechStack } from "./detect-folder-tech-stack.js";

// Resolve template dir tương đối với file này, không phải CWD.
// v1.2.9 fix: tsup bundle thành `dist/index.js` (single file) → __dirname = `dist/`,
// KHÔNG phải `dist/lib/`. Phải search cả 2 layout:
//   - Bundled (dist/index.js):  __dirname/templates/gitignore (= dist/templates/gitignore)
//   - Dev (src/lib/*.ts):       __dirname/../../src/templates/gitignore
//   - npm-installed src:        package_root/src/templates/gitignore (qua files field)
const __dirname = dirname(fileURLToPath(import.meta.url));

const CANDIDATE_DIRS = [
  // Bundled production: dist/index.js → __dirname = .../dist/, sibling dist/templates
  join(__dirname, "templates", "gitignore"),
  // Legacy bundled: nếu file là dist/lib/*.js (sub-bundle), templates ở dist/templates
  join(__dirname, "..", "templates", "gitignore"),
  // Dev mode (vitest/tsx run src/ trực tiếp): __dirname = src/lib/
  join(__dirname, "..", "..", "src", "templates", "gitignore"),
  // npm-installed alt: __dirname = .../dist/ → package_root/src/templates
  join(__dirname, "..", "src", "templates", "gitignore"),
];

const AVATAR_MARKER_START = "# === avatar ===";
const AVATAR_MARKER_END = "# === /avatar ===";

function readTemplate(stack: TechStack | "avatar"): string {
  for (const dir of CANDIDATE_DIRS) {
    try {
      return readFileSync(join(dir, `${stack}.txt`), "utf8");
    } catch {
      // continue
    }
  }
  throw new Error(`Không tìm thấy template gitignore cho stack "${stack}"`);
}

// Compose: generic luôn ở đầu, sau đó các stack khác theo thứ tự detect.
// Wrap trong marker để uninstall biết range gỡ chính xác.
export function composeGitignoreContent(stacks: TechStack[]): string {
  const all: TechStack[] = ["generic", ...stacks.filter((s) => s !== "generic")];
  const sections = all.map((s) => `# --- ${s} ---\n${readTemplate(s).trim()}`);
  return [AVATAR_MARKER_START, ...sections, AVATAR_MARKER_END, ""].join("\n");
}

// Block Avatar riêng cho repo trong src/ — CHỈ 4 mục mount (.claude/,
// AGENTS.md, CLAUDE.md, .gitnexus/), KHÔNG kèm generic/tech-stack. Bọc cùng
// marker để hàm merge (ticket #138 phase-02: ghi vào <git-common-dir>/
// info/exclude — không còn .gitignore của repo) idempotent (chạy lại không
// nhân đôi).
export function buildAvatarRepoGitignoreBlock(): string {
  const body = readTemplate("avatar").trim();
  return [AVATAR_MARKER_START, "# --- avatar ---", body, AVATAR_MARKER_END, ""].join("\n");
}

export { AVATAR_MARKER_END, AVATAR_MARKER_START };
